import React, { useEffect, useState } from 'react';
import { getDataRequest, getListDataRequest } from 'utils/request';
import SelectBox from 'components/SelectBox';
import TextField from 'components/TextField';
import BlueAlertBox from 'components/BlueAlertBox';
import { createMarkup } from 'tools/WebTool';
import LinkageGuideBox from '../../LinkageGuideBox';
import { DataFnqWrap } from '../style';
import Stipulation from './Stipulation';
import StyledActiveButton from 'components/Button/StyledActiveButton';
import { Card, CardName } from 'components/FoldedCard/style';
import FoldedCard from 'components/FoldedCard';
import GoBackToPrev from '../../GoBackToPrev';
import { MainWrapper } from '../style';

const FillAccountFormStep = ({
  mode,
  formData,
  selectedMallData,
  stipulationListForMall,
  setStipulationListForMall,
  dataProviderSeq,
  setFormData,
  setStep,
  resetAllData,
  accountType,
  runAccountAuthProcess,
}) => {
  // 판매몰 주요 안내
  const [mallGuide, setMallGuide] = useState('');
  // 자주 묻는 질문
  const [faqList, setFaqList] = useState([]);

  // form Key 리스트
  const formKeyList = selectedMallData.itemList?.map(item => {
    if (item?.itemId === 'id') {
      return 'mallId';
    } else if (item?.itemId === 'password') {
      return 'mallPassword';
    }
    return item?.itemId;
  });

  const { secondAuthReleaseYn, mallPassword, mallId, scrapingHasSucceededYn } =
    formData;

  const {
    dataProviderMallSeq = 0,
    secondAuthReleaseType = '',
    secondAuthReleaseMessage = '',
    mallSeq = 0,
    mallName = '',
    secondAuthUseYn = '',
    secondAuthExposureType = '',
    interlockOpenYn = '',
    secondAuthCategoryCd,
  } = selectedMallData;

  // 이전으로 돌아가기 버튼 클릭
  const onClickBackBtn = () => {
    resetAllData();
    setStep('mallStep');
  };

  // input 타입 form 입력
  const onChangeTextField = (event, type) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: type === 'IPT200' ? value : value.replace(/\s+/g, ''),
    });
  };

  // 2차 인증 해제 안내 체크박스 클릭
  const onChangeCheckBox = event => {
    const { checked } = event.target;
    setFormData(prev => ({
      ...prev,
      secondAuthReleaseYn: checked === true ? 'Y' : 'N',
    }));
  };

  // 자주 묻는 질문 상세 펼치기
  const onClickFaqDetailBtn = seq => {
    setFaqList(prev =>
      prev.map((item, index) =>
        index === seq
          ? { ...item, isOpen: !item.isOpen }
          : { ...item, isOpen: false }
      )
    );
  };

  // 최하단 다음 버튼 클릭
  const onClickNextBtn = () => {
    // 2차인증 단계로 이동
    const goContactStep =
      secondAuthUseYn === 'Y' &&
      secondAuthCategoryCd === 'SAM100' &&
      (secondAuthExposureType === 'INTERLOCK_ADD_AND_MODIFY' ||
        (secondAuthExposureType === 'INTERLOCK_MODIFY' && mode === 'modify'));

    if (goContactStep) {
      setStep('contactStep');
    } else {
      // 오픈 예정몰일 경우
      if (interlockOpenYn === 'N') {
        setStep('managerStep');
      } else {
        runAccountAuthProcess();
      }
    }
  };

  // 버튼 활성화 검증
  const isDisabledBtn = () => {
    // true: 검증 조건이 하나라도 맞지 않을 경우
    let isDisabled;
    // 기본 form 입력 확인
    isDisabled = formKeyList?.some(key => !formData[key]);

    // 2차 인증 해제 확인 체크박스
    if (secondAuthReleaseType === 'REQUIRED') {
      isDisabled = isDisabled || secondAuthReleaseYn !== 'Y';
    }

    // 약관이 있는 경우: 필수는 모두 체크되어 있어야 함
    if (stipulationListForMall?.length > 0) {
      isDisabled =
        isDisabled ||
        (mode === 'register' &&
          !stipulationListForMall
            ?.filter(item => item.required === true)
            ?.every(item => item.checked === true));
    }

    return isDisabled;
  };

  // 기본 form 컴포넌트 생성
  const makeFormComps = () => {
    return selectedMallData?.itemList
      ?.sort((a, b) => a.itemOrder - b.itemOrder)
      ?.map((item, index) => {
        switch (item.itemTypeCd) {
          case 'IPT100':
            const optionList = item?.itemDetail?.map(v => ({
              value: v.optCd,
              label: v.optNm,
            }));
            return (
              <SelectBox
                key={`${item.itemTypeCd}_${index}`}
                optionList={optionList}
                optionHandleChange={v => {
                  setFormData({
                    ...formData,
                    [item.itemId]: v.target.value,
                  });
                }}
                name={item.itemId}
                value={formData[item.itemId] ?? ''}
                isNotDisabled={true}
                noPadding={true}
                $formStyle
              />
            );
          case 'IPT200':
            return (
              <TextField
                key={`${item.itemTypeCd}_${index}`}
                name={item.itemId}
                placeholder={item.itemDetail.placeHolder}
                value={formData[item.itemId] ?? ''}
                onChange={event => onChangeTextField(event, item.itemTypeCd)}
                required
              />
            );
          case 'IPT300':
            return (
              <TextField
                key={`${item.itemTypeCd}_${index}`}
                name="mallId"
                placeholder={`${mallName} 아이디`}
                value={mallId ?? ''}
                onChange={event => onChangeTextField(event, item.itemTypeCd)}
                readOnly={
                  !(
                    mode === 'register' ||
                    (mode === 'modify' &&
                      (scrapingHasSucceededYn === 'N' ||
                        interlockOpenYn === 'N'))
                  )
                }
                required
              />
            );
          case 'IPT400':
            return (
              <TextField
                key={`${item.itemTypeCd}_${index}`}
                type="password"
                name="mallPassword"
                placeholder={`${mallName} 비밀번호`}
                value={mallPassword ?? ''}
                onChange={event => onChangeTextField(event, item.itemTypeCd)}
                required
              />
            );
        }
      });
  };

  // select 타입일 경우: 기본값(optBaseSelectYn === 'Y')으로 초기 셋팅
  useEffect(() => {
    if (mode === 'register') {
      let selectFormData = {};
      const selectTypeItemList = selectedMallData?.itemList?.filter(
        item => item?.itemTypeCd === 'IPT100'
      );
      if (selectTypeItemList?.length > 0) {
        selectTypeItemList?.forEach(item => {
          selectFormData[item.itemId] = item?.itemDetail?.find(
            v => v.optBaseSelectYn === 'Y'
          )?.optCd;
        });
      }
      setFormData({ ...formData, ...selectFormData });
    }
  }, [selectedMallData]);

  // 판매몰 주요 안내 조회 api 호출
  useEffect(() => {
    if (mallSeq && dataProviderSeq) {
      getDataRequest({
        url: `/v1/au/salesMall/guidance`,
        params: {
          guidanceExposureLocationCode: 'ACCOUNT',
          mallSeq,
          dataProviderSeq,
        },
        successFnc: data => {
          setMallGuide(data?.guidanceContents || '');
        },
      });
    }
  }, [mallSeq, dataProviderSeq]);

  // 판매몰 약관 조회 api 호출
  useEffect(() => {
    if (dataProviderMallSeq) {
      getDataRequest({
        url: `/v1/au/data-provider-mall/stipulation/${dataProviderMallSeq}`,
        successFnc: data => {
          setStipulationListForMall(
            data?.stipulationList?.map(item => ({
              ...item,
              required: item.essentialYn === 'Y',
              checked: false,
            }))
          );
        },
      });
    }
  }, [dataProviderMallSeq]);

  // 판매몰 자주묻는 질문 api 호출
  useEffect(() => {
    if (mallSeq) {
      getListDataRequest({
        url: '/v1/au/faq/interlock/list',
        params: {
          mallSeq,
        },
        successFnc: list => {
          setFaqList(list.map(item => ({ ...item, isOpen: false })));
        },
      });
    }
  }, [mallSeq]);

  return (
    <MainWrapper>
      <GoBackToPrev
        onClickReset={onClickBackBtn}
        isShowText={mode === 'register' && accountType === 'main'}
      />
      <div className="contentsWrapper">
        <p className="title">
          {`${mallName}의 계정 정보를 ${
            mode === 'register' ? '입력' : '수정'
          }해 주세요`}
          <br />
          <span>연동 가이드가 필요하신가요?</span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={
              !!mallName
                ? `${window.location.origin}/data-linkage/guide?mallName=${mallName}`
                : `${window.location.origin}/data-linkage/guide`
            }
          >
            연동 가이드 보기
          </a>
        </p>
        <div className="accountFormStepBox">
          {!!mallSeq && (
            <>
              {/* 몰 안내 */}
              {!!mallGuide && (
                <BlueAlertBox
                  background="icyRed"
                  title="주요 안내"
                  contents={
                    <div dangerouslySetInnerHTML={createMarkup(mallGuide)} />
                  }
                />
              )}
              {/* 기본 입력 form */}
              {makeFormComps()}
              {(secondAuthReleaseType === 'REQUIRED' ||
                secondAuthReleaseType === 'RECOMMENDED') && (
                <LinkageGuideBox
                  secondAuthReleaseMessage={secondAuthReleaseMessage}
                  secondAuthReleaseType={secondAuthReleaseType}
                  isChecked={secondAuthReleaseYn === 'Y'}
                  onChangeCheckBox={onChangeCheckBox}
                />
              )}
              <div className="stipulationSection">
                {/* 약관 동의  */}
                {mode === 'register' &&
                  stipulationListForMall?.length > 0 &&
                  !!stipulationListForMall[0]
                    .dataProviderMallStipulationMappingSeq && (
                    <Stipulation
                      stipulationList={stipulationListForMall}
                      setStipulationList={setStipulationListForMall}
                    />
                  )}
              </div>
              <div className="nextBtnBox">
                <StyledActiveButton
                  onClick={onClickNextBtn}
                  disabled={isDisabledBtn()}
                >
                  다음
                </StyledActiveButton>
              </div>
            </>
          )}
        </div>
      </div>
      {faqList?.length > 0 && (
        <DataFnqWrap>
          <Card style={{ borderBottom: 'none', padding: '4px 0' }}>
            <CardName style={{ fontWeight: 500 }}>
              데이터 연동 시 자주 찾는 질문이에요.
            </CardName>
          </Card>
          {faqList.map((item, index) => {
            return (
              <FoldedCard
                key={`FoldedCard_${index}`}
                index={index}
                isOpen={item.isOpen}
                title={item.subject}
                contents={item.contents}
                onClickDetailBtn={onClickFaqDetailBtn}
                style={{ padding: '8px 0' }}
                blackArrow={true}
              />
            );
          })}
        </DataFnqWrap>
      )}
    </MainWrapper>
  );
};

export default FillAccountFormStep;
